/**
 * Close Modal
 * @description Close Newsletter Modal on click
 */

/**
 * Module Dependencies
 */
var $ = require('jquery'),
    Util = require('./util'),
    Cookie = require('js-cookie'),
    subscribed = Cookie.get('subscribed');
    visited = Cookie.get('visited');

/**
 * Module Vars
 */
var debugEnabled = false,
    debug = debugEnabled ? Util.debug : function() {};

/**
 * Initializes Module
 */
function init() {
    debug('Close Modal');
    showModal();
    closeModal();
    closeSectionModal();
}

function closeModal() {

    $('.newsletter-close-modal').click(function() {
        Cookie.set('visited', true, { expires: 1 });
        $('.newsletter-modal').addClass('fade').one('transitionend', function() {
            $('.newsletter-modal').removeClass('fade')
            $('.newsletter-modal').removeClass('show')
            $('.newsletter-modal-background').removeClass('fade, show').one('transitionend', function() {
                $(this).addClass('hide');
            })
        })
    })

}

function closeSectionModal() {

    $('.section-close-modal').click(function() {
        $('.section-modal-background, .section-modal').addClass('fade').one('transitionend', function() {
            Cookie.set('visited', true, { expires: 1 });
            $('.section-modal').removeClass('fade')
            $('.section-modal').removeClass('show')
            $('.section-modal-background').removeClass('fade show').one('transitionend', function() {
                $(this).addClass('hide');
            })
        })
    })

}

function stickModal() {

    $(window).scroll(function(){

        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = $('.page-footer').offset().top;


        if (elemTop <= docViewBottom) {
            $('.newsletter-modal-background').addClass('stick');
        } else {
            $('.newsletter-modal-background').removeClass('stick');
        }

    });

}

function showModal() {

    if (subscribed === 'true' || visited === 'true') {
        return;
    } else if ($('.section-modal').data('show') === true) {
        stickModal();
        $('.section-modal').addClass('show')
        $('.section-modal-background').addClass('show')
    }
}

/**
 * Module Exports
 */
module.exports = {
    init: init
};